/* eslint-disable */
import { CommonGet } from '../../../helpers/HttpClient';


export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetViewGrnInformationByGroupIdFactoryIdDate,
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetViewGrnInformationByGroupIdFactoryIdDate(groupID, factoryID, date) {
    const response = await CommonGet('/api/GoodRecieveNote/GetGoodReciveNoteDetails', 'groupID=' + parseInt(groupID)
        + '&factoryID=' + parseInt(factoryID) + '&date=' + date);
    return response.data;
}






